import SimpleIndicator from './SimpleIndicator';

export default SimpleIndicator;
